import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { RiErrorWarningLine } from "react-icons/ri";

Modal.setAppElement("#root");

const PopupError = ({ errType, errMsg, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const modalOverlayStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    zIndex: 1000,
    transition: "opacity 0.3s ease-in-out",
    opacity: isAnimating ? 1 : 0,
  };

  const modalContentStyle = {
    position: "relative",
    border: "2px solid rgb(204, 204, 204)",
    background: "rgb(255, 255, 255)",
    borderRadius: "8px",
    outline: "none",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 10px",
    textAlign: "center",
    maxWidth: "400px",
    maxHeight: "200px",
    width: "100%",
    padding: "20px",
    top: 0,
    marginTop: "20px",
    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
    opacity: isAnimating ? 1 : 0,
    transform: isAnimating ? "translateY(0)" : "translateY(-50%)",
  };

  const closeButtonStyle = {
    padding: "5px 17px",
    backgroundColor: "rgb(9, 21, 44)",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  };

  const errorTextStyle = {
    color: "#121b2f",
    fontWeight: 600,
  };

  const iconStyle = {
    margin: "5px",
    fontSize: "25px",
    color: "rgb(255, 53, 2)",
  };
  const alertStyle = {
    fontWeight: 600,
    fontSize: "15px",
    color: "rgb(255, 53, 2)",
  };

  const handleAfterOpen = () => {
    setIsAnimating(true);
  };

  const handleAfterClose = () => {
    setIsAnimating(false);
  };

  return (
    <Modal
      isOpen={true}
      style={{
        overlay: modalOverlayStyle,
        content: modalContentStyle,
      }}
      onAfterOpen={handleAfterOpen}
      onAfterClose={handleAfterClose}
    >
      <span style={alertStyle}>ALERT&nbsp; :&nbsp; {errType}</span>
      <br />
      <RiErrorWarningLine style={iconStyle} />
      <p style={errorTextStyle}>{errMsg}</p>

      <button onClick={onClose} style={closeButtonStyle}>
        ok
      </button>
    </Modal>
  );
};

PopupError.propTypes = {
  errType: PropTypes.string.isRequired,
  errMsg: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PopupError;
